import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 *  EAN-13 VONALKÓD a képernyőn – egy külső pénztárgép olvasója erről olvassa be (Kassza → Micra árvonalkód).
 *  Szabványos kódolás (GS1): bal oldal L/G mintái az első jegy szerint, jobb oldal R; széles csendes zóna, hogy a
 *  kézi olvasó a képernyőről is biztosan olvasson.
 */
const L = ['0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'];
const R = L.map((p) => p.replace(/./g, (b) => (b === '1' ? '0' : '1')));
const G = R.map((p) => p.split('').reverse().join(''));
const PARITAS = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];

/** A 13 jegyű kód modulsorozata (1 = sötét), a vezetőcsíkok helyével. */
export function ean13Bitek(kod: string): { bitek: string; vezeto: Set<number> } | null {
  if (!/^\d{13}$/.test(kod)) return null;
  const d = kod.split('').map(Number);
  let bitek = '101';
  for (let i = 1; i <= 6; i++) bitek += (PARITAS[d[0]][i - 1] === 'L' ? L : G)[d[i]];
  bitek += '01010';
  for (let i = 7; i <= 12; i++) bitek += R[d[i]];
  bitek += '101';
  const vezeto = new Set([0, 1, 2, 45, 46, 47, 48, 49, 92, 93, 94]);
  return { bitek, vezeto };
}

@Component({
  selector: 'app-ean13-kod',
  standalone: true,
  imports: [CommonModule],
  template: `
    <svg *ngIf="sav" [attr.viewBox]="'0 0 ' + szel + ' ' + (mag + 14)" class="e13" [style.max-width.px]="szel * 3" role="img" [attr.aria-label]="kod">
      <rect x="0" y="0" [attr.width]="szel" [attr.height]="mag + 14" fill="#fff"></rect>
      <rect *ngFor="let s of sav" [attr.x]="s.x" y="2" [attr.width]="s.w" [attr.height]="s.hosszu ? mag + 6 : mag" fill="#000"></rect>
      <text [attr.x]="szel / 2" [attr.y]="mag + 12" text-anchor="middle" font-family="monospace" font-size="9" fill="#000">{{ kod }}</text>
    </svg>
    <span *ngIf="!sav" class="e13-hiba">Hibás kód: {{ kod }}</span>`,
  styles: [`:host { display: block; } .e13 { width: 100%; height: auto; display: block; margin: 0 auto; } .e13-hiba { color: #b42318; }`],
})
export class Ean13KodComponent implements OnChanges {
  @Input() kod = '';
  /** Csendes zóna modulban (a szabvány bal 11, jobb 7; a képernyőhöz bővebb). */
  private readonly csend = 14;
  sav: { x: number; w: number; hosszu: boolean }[] | null = null;
  szel = 0;
  readonly mag = 60;

  ngOnChanges() {
    const e = ean13Bitek(this.kod);
    if (!e) { this.sav = null; return; }
    this.szel = e.bitek.length + 2 * this.csend;
    const s: { x: number; w: number; hosszu: boolean }[] = [];
    for (let i = 0; i < e.bitek.length; i++) {
      if (e.bitek[i] !== '1') continue;
      const elozo = s[s.length - 1];
      //  szomszédos sötét modulok egy csíkká, hogy a képernyőn ne legyen hajszálrés
      if (elozo && elozo.x + elozo.w === i + this.csend && elozo.hosszu === e.vezeto.has(i)) elozo.w++;
      else s.push({ x: i + this.csend, w: 1, hosszu: e.vezeto.has(i) });
    }
    this.sav = s;
  }
}
